module.exports = "https://web-assets.ifttt.com/packs/media/access_applet_card/install-count-75c2ebba.svg";